<template>
  <div id="myMap"
       ref="myMap"
       style="width:100%; height: 100%"></div>
</template>
<script>
var dataMap;
var specialMap;
let option;
import cityMap from '../echart/chinaCityGeo.json'
// var data = [{ name: "北京市", value: "12" }];
export default {
  props: ['data'],
  name: "HeatMap",
  mounted () {
    this.init()
  },
  methods: {
    randomData () {
      return Math.round(Math.random() * 500);
    },
    init () {
      dataMap = [
        { name: '北京', value: '100' }, { name: '天津', value: this.randomData() },
        { name: '上海', value: this.randomData() }, { name: '重庆', value: this.randomData() },
        { name: '河北', value: this.randomData() }, { name: '河南', value: this.randomData() },
        { name: '云南', value: this.randomData() }, { name: '辽宁', value: this.randomData() },
        { name: '黑龙江', value: this.randomData() }, { name: '湖南', value: this.randomData() },
        { name: '安徽', value: this.randomData() }, { name: '山东', value: this.randomData() },
        { name: '新疆', value: this.randomData() }, { name: '江苏', value: this.randomData() },
        { name: '浙江', value: this.randomData() }, { name: '江西', value: this.randomData() },
        { name: '湖北', value: this.randomData() }, { name: '广西', value: this.randomData() },
        { name: '甘肃', value: this.randomData() }, { name: '山西', value: this.randomData() },
        { name: '内蒙古', value: this.randomData() }, { name: '陕西', value: this.randomData() },
        { name: '吉林', value: this.randomData() }, { name: '福建', value: this.randomData() },
        { name: '贵州', value: this.randomData() }, { name: '广东', value: this.randomData() },
        { name: '青海', value: this.randomData() }, { name: '西藏', value: this.randomData() },
        { name: '四川', value: this.randomData() }, { name: '宁夏', value: this.randomData() },
        { name: '海南', value: this.randomData() }, { name: '台湾', value: this.randomData() },
        { name: '香港', value: this.randomData() }, { name: '澳门', value: this.randomData() }, { name: '南海诸岛', value: this.randomData() }
      ];
      // 需要在页面上直接标记出来的城市

      specialMap = [];
      // 对dataMap进行处理，使其可以直接在页面上展示
      for (var i = 0; i < specialMap.length; i++) {
        for (var j = 0; j < dataMap.length; j++) {
          if (specialMap[i] == dataMap[j].name) {
            dataMap[j].selected = true;
            break;
          }

        }
      }

      option = {
        tooltip: {
          formatter: function (params) {
            var info = '<p style="font-size:18px">' + params.name + '</p><p style="font-size:14px">这里可以写一些，想展示在页面上的别的信息</p>'
            return info;
          },
          backgroundColor: "#ff7f50",//提示标签背景颜色
          textStyle: { color: "#fff" } //提示标签字体颜色
        },
        //左侧小导航图标
        visualMap: {
          show: true,
          x: 'left',
          y: 'center',
          splitList: [
            { start: 500, end: 600 }, { start: 400, end: 500 },
            { start: 300, end: 400 }, { start: 200, end: 300 },
            { start: 100, end: 200 }, { start: 0, end: 100 },
          ],
          color: ['#5475f5', '#9feaa5', '#85daef', '#74e2ca', '#e6ac53', '#9fb5ea']
        },
        series: [
          {
            name: '中国',
            type: 'map',
            mapType: 'china',

            label: {
              normal: {
                show: true,//显示省份标签
              },
              emphasis: {
                show: true,//对应的鼠标悬浮效果
              }
            },

            data: dataMap
          }
        ]
      };
      //初始化echarts实例
      var myChart = this.$echarts.init(this.$el);;
      //使用制定的配置项和数据显示图表
      myChart.setOption(option);

    }
  }
}
</script>
<style scoped>
canvas {
  width: 100%;
}
#myMap {
  background: transparent;
}
</style>
